var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infinite-scroll-spinner",class:{ inactive: !_vm.loading }},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('Spinner',{attrs:{"size":"32px"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }